Config = {
    bucket: 'vuejs-photo-gallery'
};

module.exports = Config;


// WEBPACK FOOTER //
// ./src/config.js